import { Component } from '@angular/core';

declare let ga: Function;

@Component({
  selector: 'body',
  template: '<router-outlet></router-outlet>',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts